import script from "./CompetitionView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompetitionView.vue?vue&type=script&lang=ts&setup=true"

import "./CompetitionView.vue?vue&type=style&index=0&id=bfecc2ce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfecc2ce"]])

export default __exports__